import { atom } from 'jotai';

export const inboxListCountAtom = atom<InboxNotificationList | null>(null);

export const inboxList = atom(null);

export interface InboxNotificationList {
  content: NotificationItem[];
  pageable: {
    sort: Sort;
    pageSize: number;
    pageNumber: number;
    offset: number;
    paged: boolean;
    unpaged: boolean;
  };
  totalElements: number;
  last: boolean;
  totalPages: number;
  first: boolean;
  sort: Sort;
  numberOfElements: number;
  size: number;
  number: number;
  empty: boolean;
}

export interface NotificationItem {
  createdBy: number;
  createdDate: number;
  lastModifiedBy: number | null;
  lastModifiedDate: number;
  id: number;
  subject: string;
  content: string;
  messageData: {
    id: string;
    templateId: string;
    telegramTemplateId: string;
    messageName: TranslatedText;
    roles: TranslatedText[];
    values: {
      key: string;
      entity: string;
      field: string;
      link: string | null;
      ordinal: number;
    }[];
  };
  read: boolean;
  memberId: number;
  category: Category;
  link: {
    id: number;
    linkedId: number;
    link: string;
    brand: {
      id: number;
      name: string;
      code: string;
      companyId: number;
      companyName: string;
      companyCode: string;
      logo: FileMeta;
      fileStorageId: number;
      pushKey: string | null;
      defaultLanguage: string;
      terms: Record<string, FileMeta>;
      dates: Record<string, number>;
      properties: Record<string, string>;
      social: {
        platform: TranslatedText & { id: number };
        active: boolean;
      }[];
    };
    connection: {
      staticPath: {
        id: number;
        code: string;
        name: string;
        translate: string;
        uze: boolean;
        linkUrl: string;
      };
      path: string;
    };
    clientType: TranslatedText;
    auditor: {
      register: Member;
      modifier: Member;
    };
  };
  attachment: any;
  applicationType: string;
}

export interface TranslatedText {
  value: string;
  text: string;
  translate: string;
  customValues: Record<string, unknown>;
}

export interface Category {
  value: number;
  text: string;
  translate: string;
  child: Category | null;
}

export interface Member {
  id: number;
  name: {
    first: string;
    last: string;
    fullName: string;
  };
  status: TranslatedText;
  brandName: string;
  storeName: string;
  dutyName: string;
  responsibilityName: string;
  userId: string;
  point: number;
  levelName: string;
  time: number;
  profile: {
    file: FileMeta;
    defaultBackgroundColor: string;
    pattern: {
      backgroundColor: string | null;
      defaultColor: string | null;
      patternColor: string | null;
      patternValue: unknown[];
    };
  };
  maskingMemberStatus: string;
  deactivatedUser: boolean;
}

export interface FileMeta {
  id: number;
  name: string;
  contentType: string;
  originalName: string;
  resourceUri: string;
  width: number;
  height: number;
  duration: number;
  ext: string;
  chunkCount: number;
  size: number;
  subFileResourceUri: string[];
  isUnzip: boolean;
}

export interface Sort {
  sorted: boolean;
  unsorted: boolean;
  empty: boolean;
}
